import { render, staticRenderFns } from "./borrowManageList.vue?vue&type=template&id=2cea20ba&scoped=true"
import script from "./borrowManageList.vue?vue&type=script&lang=js"
export * from "./borrowManageList.vue?vue&type=script&lang=js"
import style0 from "./borrowManageList.vue?vue&type=style&index=0&id=2cea20ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cea20ba",
  null
  
)

export default component.exports